/**
 * The Import QuickBooks Configuration section (T4-179) shows only behind the feature flag, and only
 * while QuickBooks is connected. The same condition as shouldShowQboExportDefaults today, kept
 * separate because the two features may diverge.
 */
export const shouldShowQboConfigImport = (hasFlag: boolean, quickbooksEnabled: boolean): boolean =>
	hasFlag && quickbooksEnabled;
